import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_GET_ALL_AGENTS_BEGIN,
  MANAGE_SUBS_GET_ALL_AGENTS_SUCCESS,
  MANAGE_SUBS_GET_ALL_AGENTS_FAILURE,
  MANAGE_SUBS_GET_ALL_AGENTS_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function getAllAgents(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_GET_ALL_AGENTS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.get(`${API_REQUEST_URL}/getAllAgents`, {
        headers: {
          Authorization: token,
        },
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_GET_ALL_AGENTS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_GET_ALL_AGENTS_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetAllAgentsError() {
  return {
    type: MANAGE_SUBS_GET_ALL_AGENTS_DISMISS_ERROR,
  };
}

export function useGetAllAgents() {
  const dispatch = useDispatch();

  const { getAllAgentsPending, getAllAgentsError } = useSelector(
    state => ({
      getAllAgentsPending: state.manageSubs.getAllAgentsPending,
      getAllAgentsError: state.manageSubs.getAllAgentsError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(getAllAgents(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetAllAgentsError());
  }, [dispatch]);

  return {
    getAllAgents: boundAction,
    getAllAgentsPending,
    getAllAgentsError,
    dismissGetAllAgentsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_GET_ALL_AGENTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getAllAgentsPending: true,
        getAllAgentsError: null,
      };

    case MANAGE_SUBS_GET_ALL_AGENTS_SUCCESS:
      // The request is success
      return {
        ...state,
        getAllAgentsPending: false,
        getAllAgentsError: null,
      };

    case MANAGE_SUBS_GET_ALL_AGENTS_FAILURE:
      // The request is failed
      return {
        ...state,
        getAllAgentsPending: false,
        getAllAgentsError: action.data.error,
      };

    case MANAGE_SUBS_GET_ALL_AGENTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getAllAgentsError: null,
      };

    default:
      return state;
  }
}
